import {Component, OnInit, ViewChild} from '@angular/core';
import {CmsComponentData} from '@spartacus/storefront';
import {CmsNavigationComponent} from '@spartacus/core';
import {take} from 'rxjs/operators';
import {DropdownPositionDirective} from '@app/directives/dropdown/dropdown-position.directive';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-navigation-component-manager',
  templateUrl: './navigation-component-manager.component.html'
})
export class NavigationComponentManagerComponent implements OnInit {
  @ViewChild(DropdownPositionDirective, {static: false}) dropdownPositionDirective: DropdownPositionDirective;
  currentComponentStyleClass: string;
  quickLinksClass: string = 'QuickLinksNavigationClass';
  helpIconClass: string = 'HelpIconNavComponentClass';
  userMenuClass: string = 'UserMenuNavComponentClass';

  constructor(private component: CmsComponentData<CmsNavigationComponent>) {
  }

  ngOnInit() {
    this.component.data$.pipe(take(1), untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.currentComponentStyleClass = data.styleClass;
      }
    });
  }
}
